






































import { Menu } from 'ant-design-vue'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue'
import { MenuDropdown } from '../../NewConfig'
import SidebarIcon from './SidebarIcon.vue'
import SidebarSingleItem from './SidebarSingleItem.vue'
import SidebarTag from './SidebarTag.vue'

@Component({
  name: 'SidebarDropdown',
  components: {
    SidebarTag,
    SidebarIcon,
    SidebarSingleItem,
    Icon,
  },
  props: {
    ...(Menu.SubMenu as any).props,
  },
})
export default class SidebarDropdown extends Vue {
  @VModel({ type: Boolean }) menuCollapsed!: boolean

  @Prop({ required: true, type: Object }) item!: MenuDropdown

  @Emit('itemClick')
  itemClick(url: string) {
    return url
  }
}
